import contratacoesRotas from './contratacoes/ContratacoesRotas'
import entregasRotas from './entregas/EntregasRotas'
import apoiosRotas from './apoios/ApoiosRotas'
import gestoresDesignadosRotas from './gestoresdesignados/GestoresDesignadosRotas'
import solicitacoesReaberturasRotas from './solicitacoesreaberturas/SolicitacoesReaberturasRotas'

export default {
    path: 'gerentes',
    name: 'Gerentes',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        contratacoesRotas,
        entregasRotas,
        apoiosRotas,
        gestoresDesignadosRotas,
        solicitacoesReaberturasRotas
    ]
}
